import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import {
    DataTable,
    TextInput,
    Button
} from 'carbon-components-react';
import Select from 'react-select';
import { Breadcrumb, Card } from '../../../components';
import { getByDmService, pathDmService } from '../../../services/Api';

const {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    TableHeader
} = DataTable;

class GestaoPedidos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            numeroPedido: '',
            novoStatus: '',
            pedidoEncontrado: null,
            carregando: false,
            listaStatus: [],
        };
    }

    async componentDidMount() {
        try {
            const data = await getByDmService('/Pedido/GetAllStatus', '');
            if (data && Array.isArray(data)) {
                const options = data.map(s => ({ value: s.id, label: s.nome }));
                this.setState({ listaStatus: options });
            }
        } catch (error) {
            console.error("Erro ao carregar lista de status", error);
        }
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    }

    handleStatusChange = (selectedOption) => {
        this.setState({ novoStatus: selectedOption });
    }

    buscarPedido = async () => {
        const { numeroPedido } = this.state;
        if (!numeroPedido) {
            toast.warn("Informe o número do pedido.");
            return;
        }

        this.setState({ carregando: true, pedidoEncontrado: null });

        try {
            const numeroLimpo = numeroPedido.replace(/\D/g, '');
            if (!numeroLimpo) {
                toast.warn("Número de pedido inválido.");
                this.setState({ carregando: false });
                return;
            }

            const dataId = await getByDmService('/Pedido/BuscarIdPorNumero', numeroLimpo);
            if (!dataId || !dataId.id) {
                toast.error("Pedido não encontrado.");
                this.setState({ carregando: false });
                return;
            }

            const data = await getByDmService('/Pedido/GetAgenciaAtendente', dataId.id);
            if (data && data.id) {
                this.setState({ pedidoEncontrado: data });
                toast.success("Pedido encontrado!");
            } else {
                toast.error("Detalhes do pedido não encontrados.");
            }
        } catch (error) {
            console.error(error);
            toast.error("Erro ao buscar o pedido.");
        } finally {
            this.setState({ carregando: false });
        }
    }

    atualizarStatus = async () => {
        const { pedidoEncontrado, novoStatus } = this.state;

        if (!pedidoEncontrado) {
            toast.warn("Busque um pedido primeiro.");
            return;
        }

        if (!novoStatus || !novoStatus.value) {
            toast.warn("Selecione o novo status.");
            return;
        }

        this.setState({ carregando: true });

        try {
            await pathDmService(`/Pedido/AtualizaStatus/${pedidoEncontrado.id}?status=${novoStatus.value}`, {});
            toast.success("Status atualizado com sucesso!");
            this.buscarPedido(); // Recarrega os dados
        } catch (error) {
            console.error(error);
            toast.error("Erro ao atualizar o status do pedido.");
        } finally {
            this.setState({ carregando: false });
        }
    }

    render() {
        const { numeroPedido, novoStatus, pedidoEncontrado, carregando } = this.state;

        return (
            <div className="bx--grid bx--grid--full-width p-3">
                <Breadcrumb items={[{ label: 'Início', link: '/' }, { label: 'Gestão de Pedidos', link: null }]} />
                <Card title="Gestão de Pedidos (Avançado)">
                    <div className="bx--row v-lg-margin">
                        <div className="bx--col-md-4 bx--col-xs-12 v-md-margin">
                            <TextInput
                                id="numeroPedido"
                                name="numeroPedido"
                                labelText="Buscar Pedido (Número)"
                                placeholder="Exemplo: A000469"
                                value={numeroPedido}
                                onChange={this.handleInputChange}
                            />
                        </div>
                        <div className="bx--col-md-2 bx--col-xs-12 v-md-margin" style={{ display: 'flex', alignItems: 'flex-end' }}>
                            <Button onClick={this.buscarPedido} disabled={carregando}>
                                Buscar
                            </Button>
                        </div>
                    </div>

                    {pedidoEncontrado && (
                        <div className="bx--row v-lg-margin">
                            <div className="bx--col-md-12 bx--col-xs-12 v-md-margin">
                                <h4>Detalhes do Pedido</h4>
                                <div className="v-sm-margin">
                                    <p><strong>Número:</strong> {pedidoEncontrado.numero}</p>
                                    <p><strong>Status Atual:</strong> {pedidoEncontrado.status} (ID: {pedidoEncontrado.statusId})</p>
                                    <p><strong>Nome:</strong> {pedidoEncontrado.nomePedido}</p>
                                </div>
                            </div>

                            <div className="bx--col-md-4 bx--col-xs-12 v-md-margin">
                                <label className="bx--label">Novo Status</label>
                                <Select
                                    className="search-dm"
                                    name="novoStatus"
                                    options={this.state.listaStatus}
                                    value={novoStatus}
                                    onChange={this.handleStatusChange}
                                    placeholder="Selecione um status..."
                                    isClearable
                                    isSearchable
                                />
                            </div>
                            <div className="bx--col-md-3 bx--col-xs-12 v-md-margin" style={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Button kind="danger" onClick={this.atualizarStatus} disabled={carregando}>
                                    Forçar Status
                                </Button>
                            </div>
                        </div>
                    )}
                </Card>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    isAdmin: state.main.showAdminMenu
});

export default connect(mapStateToProps)(GestaoPedidos);



// WEBPACK FOOTER //
// ./src/screens/admin/GestaoPedidos/index.js